import styled from "styled-components";

export const DivH = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    text-align: right;
`;